import type { ChatMessage } from '../types'
import type { UIActionPayload } from './chat-api'

let uiActionCounter = 0

export function mapUIActionToMessage(action: UIActionPayload): ChatMessage | null {
  const id = `ui-action-${++uiActionCounter}`

  switch (action.action) {
    case 'role_select':
      return {
        id,
        role: 'agent',
        type: 'role-select',
        content: 'Select your role',
        choices: action.options.map((opt) => ({
          label: opt.label,
          value: opt.label.toLowerCase(),
          description: opt.description,
        })),
      }

    case 'identity_prompt':
      // Hidden message — not rendered, but exists so handleChatSend can detect
      // pending identity input and route it as an identity_input action.
      return {
        id,
        role: 'agent',
        type: 'identity-prompt',
        content: '',
      }

    case 'confirm_info':
      return {
        id,
        role: 'agent',
        type: 'confirm-info',
        content: 'Your complete profile',
        infoSections: action.sections.map((section) => ({
          title: section.title,
          items: section.fields.map((field) => ({
            label: field.label,
            value: field.value,
          })),
        })),
      }

    case 'multi_select':
      return {
        id,
        role: 'agent',
        type: 'multi-select',
        content: action.label,
        options: action.options.map((opt) => ({
          label: opt,
          value: opt.toLowerCase().replace(/[\s/]+/g, '-'),
        })),
      }

    case 'complete_onboarding':
      return null
  }
}
